// src/models/geral/CidadeCep.js
export const normalizarCep = (cep) => (cep || '').toString().replace(/\D/g, '');
export const formatarCep = (cep) => normalizarCep(cep).replace(/^(\d{5})(\d{3})$/, '$1-$2');

export class CidadeCep {
  constructor(cidadeId = 0, cep = '') {
    this.id = 0;
    this.cidadeId = cidadeId;
    this.cep = cep;
  }
}
